'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-jsx-runtime.production.min.js');
} else {
  module.exports = require('./cjs/react-jsx-runtime.development.js');
}



//////////////////
// WEBPACK FOOTER
// ../react/jsx-runtime.js
// module id = 3
// module chunks = 22